<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="12" sm="2" md="1"> </v-col>
      <v-col cols="6" sm="5" md="2">
        <strong>Famille d'informations</strong>
      </v-col>
      <v-col cols="6" sm="5" md="3">
        <strong>Éléments de la Famille</strong>
      </v-col>
      <v-col cols="12" md="5">
        <strong>Valeur</strong>
      </v-col>
      <v-col cols="1" class="d-none d-md-flex"> </v-col>
    </v-row>

    <v-row v-for="(elem, id) in selection" :key="id">
      <v-col cols="12" sm="2" md="1" class="pb-0 pt-1">
        <template v-if="id > 0">
          <v-select
            v-model="elem.composition"
            :items="enums.composition"
            append-icon=""
            item-text="libelle"
            item-value="code"
            dense
            solo
            hide-details
            @change="calculerRecherche"
          />
        </template>
      </v-col>

      <v-col cols="6" sm="5" md="2" class="pb-0 pt-1">
        <v-select
          v-model="elem.famille"
          :items="familleInformations"
          item-text="libelle"
          item-value="code"
          dense
          filled
          hide-details
          @change="changementFamille(id)"
        />
      </v-col>

      <v-col cols="6" sm="5" md="3" class="pb-0 pt-1">
        <v-select
          v-model="elem.propriete"
          :items="proprietesFamille(elem.famille)"
          item-text="libelle"
          item-value="propriete"
          dense
          filled
          hide-details
          @change="changementPropriete(id)"
        />
      </v-col>

      <v-col cols="11" md="5" class="pb-0 pt-1">
        <template v-if="elem.type === 'operateur'">
          <div class="d-flex">
            <v-select
              style="max-width:180px;"
              v-model="elem.operateur"
              :items="enums.operateur"
              item-text="libelle"
              item-value="code"
              dense
              filled
              hide-details
              @change="calculerRecherche"
            />
            <v-text-field
              v-model.trim="elem.valeur"
              class="pl-1"
              dense
              filled
              hide-details
              @input="calculerRecherche"
              append-icon="search"
              :placeholder="elem.libelle"
            />
          </div>
        </template>

        <template v-if="elem.type === 'cle'">
          <template v-if="elem.mode === 'enumeration'">
            <v-select
              v-model="elem.valeur"
              :items="enums[elem.enumeration]"
              item-text="libelle"
              item-value="id"
              dense
              filled
              hide-details
              @change="calculerRecherche"
              :placeholder="elem.libelle"
            />
          </template>

          <template v-if="elem.mode === 'lazy'">
            <enumAutocomplete
              v-model="elem.valeur"
              :type="elem.propriete"
              @input="calculerRecherche"
              dense
              filled
              hide-details
              :placeholder="elem.libelle"
            />
          </template>

          <template v-if="elem.mode === 'entier'">
            <v-text-field
              v-model="elem.valeur"
              class="pl-1"
              dense
              filled
              hide-details
              @input="calculerRecherche"
              append-icon="search"
              :placeholder="elem.libelle"
              type="number"
            />
          </template>

          <template v-if="elem.mode === 'spec'">
            <entitySearch
              v-model="elem.valeur"
              :libelle="elem.libelle"
              :type="elem.entite"
              @input="calculerRecherche"
            />
          </template>
        </template>

        <template v-if="elem.type === 'bool'">
          <v-switch
            v-model="elem.valeur"
            :label="elem.libelle"
            @change="calculerRecherche"
            hide-details
            class="mt-0"
          />
        </template>

        <template v-if="elem.type === 'date'">
          <dateSearch
            v-model="elem.valeur"
            :libelle="elem.libelle"
            @change="calculerRecherche"
            class="mt-0"
          />
        </template>
      </v-col>
      <v-col cols="1" class="pb-0 pt-1">
        <v-btn icon v-if="id > 0" @click="supprimerClause(id)">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex">
        <v-spacer />
        <v-btn small text class="mr-2" @click="supprimerClauses"
          >Effacer les critères</v-btn
        >
        <v-btn small outlined color="secondary" @click="ajouterClause"
          >Ajouter un critère</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
function operateur(propriete, libelle) {
  return {
    propriete,
    libelle,
    type: 'operateur',
  };
}

function date(propriete, libelle) {
  return {
    propriete,
    libelle,
    type: 'date',
  };
}

function booleen(propriete, libelle) {
  return {
    propriete,
    libelle,
    type: 'bool',
  };
}

function entier(propriete, libelle) {
  return {
    propriete,
    libelle,
    type: 'cle',
    mode: 'entier',
  };
}

function clePrimaire(propriete, enumeration, libelle) {
  return {
    propriete,
    libelle,
    type: 'cle',
    mode: 'enumeration',
    enumeration: enumeration,
  };
}

function clePrimaireLazy(propriete, libelle) {
  return {
    propriete,
    libelle,
    type: 'cle',
    mode: 'lazy',
  };
}

function clePrimaireSpec(propriete, libelle, entite) {
  return {
    propriete,
    libelle,
    type: 'cle',
    mode: 'spec',
    entite: entite,
  };
}

function elementParDefaut(composition = true) {
  const element = {
    famille: 'CONTACT',
    propriete: 'nom',
    type: 'operateur',
    libelle: 'Nom',
    operateur: 'EGAL',
    enumeration: null,
    lazySearch: null,
    mode: null,
    entite: null,
    valeur: null,
  };
  if (composition) element.composition = 'ET';
  return element;
}

function updateSelect(select, prop) {
  copiePropriete(select, prop);
  select.valeur = prop.type === 'bool' ? true : null;
  select.operateur = prop.type === 'operateur' ? 'EGAL' : null;
}

function copiePropriete(select, prop) {
  select.propriete = prop.propriete;
  select.libelle = prop.libelle;
  select.type = prop.type;
  select.mode = prop.mode;
  select.enumeration = prop.enumeration;
  select.entite = prop.entite;
}

export default {
  mounted() {
    this.$api('enums/rechercheavancee')
      .get()
      .then(res => {
        const body = res.body;
        this.enums.typeAcces.push.apply(this.enums.typeAcces, body.typeAcces);
        this.enums.fonctionContact.push.apply(
          this.enums.fonctionContact,
          body.fonctionContact,
        );
        this.enums.typeContact.push.apply(
          this.enums.typeContact,
          body.typeContact,
        );
        this.enums.typePersonneMorale.push.apply(
          this.enums.typePersonneMorale,
          body.typePersonneMorale,
        );
        this.enums.cotisable.push.apply(this.enums.cotisable, body.cotisable);
        this.enums.contexte.push.apply(this.enums.contexte, body.contexte);
      });
  },
  props: {
    initial: {
      type: Array,
    },
  },
  data() {
    const familleInformations = [
      {
        code: 'CONTACT',
        libelle: 'Contact',
        proprietes: [
          operateur('nom', 'Nom'),
          entier('id', 'N° Id'),
          operateur('prenoms', 'Prénom'),
          operateur('telephone', 'Téléphone'),
          operateur('mail', 'Mail'),
          clePrimaire('acces', 'typeAcces', 'Type accès'),
          operateur('titre', 'Titre'),
          clePrimaire('fonction', 'fonctionContact', 'Fonction du contact'),
          clePrimaire('type', 'typeContact', 'Type du contact (MDL)'),
          clePrimaireLazy('ville', 'Ville'),
          clePrimaireLazy('pays', 'Pays'),
          clePrimaireLazy('region', 'Région'),
          operateur('codePostal', 'Code postal'),
          operateur('departement', 'Département'),
          booleen('principal', 'Principal'),
        ],
      },
      {
        code: 'PERSONNEMORALE',
        libelle: 'Personne morale',
        proprietes: [
          operateur('nomUsuel', 'Nom usuel'),
          operateur('raisonSociale', 'Raison sociale'),
          entier('id', 'N° Id'),
          operateur('sirenOuSiret', 'Siren / Siret'),
          clePrimaire('type', 'typePersonneMorale', 'Forme juridique'),
          booleen('domicilieeMDL', 'Domiciliée MDL'),
          booleen('organisationPro', 'Organisation professionnelle'),
          clePrimaireSpec('filialeDe', 'Filiale de', 'personnemorale'),
          clePrimaire('contexte', 'contexte', 'Contexte'),
          clePrimaire('cotisable', 'cotisable', 'Cotise à'),
          clePrimaireLazy('ville', 'Ville'),
          clePrimaireLazy('pays', 'Pays'),
          clePrimaireLazy('region', 'Région'),
          operateur('codePostal', 'Code postal'),
          operateur('departement', 'Département'),
        ],
      },
      {
        code: 'INSTANCE',
        libelle: 'Instance',
        proprietes: [
          operateur('nom', 'Nom'),
          entier('id', 'N° Instance'),
          operateur('description', 'Description'),
          operateur('urlSharepoint', 'URL Sharepoint'),
          date('dateDebut', 'Date de début'),
          clePrimaireSpec('gestionnaire', 'Gestionnaire', 'personnephysique'),
          clePrimaireSpec('participants', 'Participant', 'participant'),
          clePrimaireSpec('referent', 'Référent', 'participant'),
        ],
      },
    ];

    var selection = [elementParDefaut(false)];
    if (this.initial && this.initial.length) {
      selection = this.creerSelection(this.initial, familleInformations);
    }

    return {
      enums: {
        typeAcces: [],
        fonctionContact: [],
        typeContact: [],
        typePersonneMorale: [],
        cotisable: [],
        contexte: [],
        composition: [
          {
            code: 'ET',
            libelle: 'Et',
          },
          {
            code: 'OU',
            libelle: 'Ou',
          },
        ],
        operateur: [
          {
            code: 'EGAL',
            libelle: 'Égal',
          },
          {
            code: 'DIFFERENT',
            libelle: 'Différent',
          },
          {
            code: 'CONTIENT',
            libelle: 'Contient',
          },
          {
            code: 'COMMENCE_PAR',
            libelle: 'Commence par',
          },
          {
            code: 'FINI_PAR',
            libelle: 'Fini par',
          },
        ],
      },
      familleInformations,
      selection,
    };
  },
  methods: {
    creerSelection(initial, familleInformations) {
      return initial.map(i => {
        const props = { ...i };
        const famille = familleInformations.find(f => f.code === props.famille);
        if (famille) {
          const propriete = famille.proprietes.find(
            p => p.propriete === props.propriete,
          );
          if (propriete) {
            copiePropriete(props, propriete);
          }
        }
        return props;
      });
    },
    creerRecherche(selection) {
      // converti en simple objet
      const recherche = selection.map(s => {
        const out = {
          famille: s.famille,
          propriete: s.propriete,
          type: s.type,
          valeur: s.valeur,
        };
        if (s.operateur) out.operateur = s.operateur;
        if (s.composition) out.composition = s.composition;
        return out;
      });

      //filtre les recherches invalides
      const ko = recherche.some(r => {
        return (
          r.valeur === null ||
          r.valeur === '' ||
          (r.type === 'operateur' && !r.operateur)
        );
      });

      if (ko || !recherche.length) {
        return null;
      } else {
        return recherche;
      }
    },
    calculerRecherche() {
      const recherche = this.creerRecherche(this.selection);
      this.$emit('change', recherche);
    },
    ajouterClause() {
      this.selection.push(elementParDefaut(true));
      this.calculerRecherche();
    },
    supprimerClauses() {
      this.selection.splice(0, this.selection.length);
      this.selection.push(elementParDefaut(false));
      this.calculerRecherche();
    },
    supprimerClause(index) {
      this.selection.splice(index, 1);
      this.calculerRecherche();
    },
    changementPropriete(index) {
      const select = this.selection[index];
      const proprietes = this.proprietesFamille(select.famille);
      const prop = proprietes.find(p => p.propriete === select.propriete);
      if (prop) {
        updateSelect(select, prop);
        this.calculerRecherche();
      }
    },
    proprietesFamille(code) {
      return this.familleInformations.find(f => f.code === code).proprietes;
    },
    changementFamille(index) {
      const select = this.selection[index];
      const prop = this.proprietesFamille(select.famille)[0];
      updateSelect(select, prop);
      this.calculerRecherche();
    },
  },
};
</script>
